import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './RoutePages.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const initialHomeData =
  typeof window !== 'undefined' ? window.__FERRYSEARCH_INITIAL_DATA__ || null : null;
const app = (
  <React.StrictMode>
    <App initialHomeData={initialHomeData} />
  </React.StrictMode>
);

if (rootElement && rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
